module.exports = __webpack_public_path__ + "img/icon-cart-open.2717c197.png";